module.exports = __webpack_public_path__ + "assets/img/257616c0705ad7750640aba678a54923.svg";